import { useState } from "react";
import { Logo } from "@/components";
import { NavLinks, ThemeToggle, MobileMenu } from "@/components/header-parts";
import { useHeaderScroll } from "@/hooks/use-header-scroll";

interface HeaderProps {
  transparent?: boolean;
}

const Header = ({ transparent = false }: HeaderProps) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const isVisible = useHeaderScroll();

  return (
    <header
      className={`${transparent ? "fixed" : "sticky"} top-0 z-50 py-2 sm:py-4 w-full transition-transform duration-300 ${
        isVisible ? "translate-y-0" : "-translate-y-full"
      }`}
    >
      <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 relative">
        <div
          className={`flex items-center justify-between h-14 sm:h-16 ${
            transparent
              ? "bg-black/20 backdrop-blur-md border border-white/10"
              : "pill-nav"
          } px-4 sm:px-6 rounded-full`}
        >
          <div className="flex items-center min-w-0">
            <a href="/" className="flex items-center">
              <Logo
                iconClassName="w-7 h-7 sm:w-8 sm:h-8"
                textClassName={`text-base sm:text-xl ${transparent ? "text-white" : ""}`}
                className="gap-1.5 sm:gap-2"
              />
            </a>
          </div>

          <NavLinks transparent={transparent} />

          <div className="flex items-center gap-2 sm:gap-4 shrink-0">
            <ThemeToggle transparent={transparent} />
            <MobileMenu
              isOpen={isMenuOpen}
              onToggle={() => setIsMenuOpen(!isMenuOpen)}
              transparent={transparent}
            />
          </div>
        </div>
        
        {/* Decorative gradient line with tapered ends */}
        <div 
          className="absolute -bottom-1 left-[8%] right-[8%] h-1 opacity-60"
          style={{
            background: 'linear-gradient(90deg, hsl(161 93% 24%), hsl(45 93% 47%), hsl(161 93% 24%), hsl(45 93% 47%), hsl(161 93% 24%))',
            backgroundSize: '300% 100%',
            maskImage: 'linear-gradient(90deg, transparent 0%, black 18%, black 82%, transparent 100%)',
            WebkitMaskImage: 'linear-gradient(90deg, transparent 0%, black 18%, black 82%, transparent 100%)',
            animation: 'gradient-shift 6s linear infinite'
          }}
          aria-hidden="true"
        />
      </div>
    </header>
  );
};

export default Header;
